export default "__VITE_ASSET__B5bXU85n__"